import { api } from './api';

export const vendorSlaService = {
    leaderboard: (params = {}) => {
        const q = new URLSearchParams();
        if (params.band) q.set('band', params.band);
        if (params.suspended != null) q.set('suspended', String(params.suspended));
        if (params.limit) q.set('limit', String(params.limit));
        const qs = q.toString();
        return api.get(`/api/admin/vendor-performance${qs ? `?${qs}` : ''}`);
    },
    detail: (vendorId) => api.get(`/api/admin/vendor-performance/${vendorId}`),
    suspend: (vendorId, body) => api.post(`/api/admin/vendor-performance/${vendorId}/suspend`, body),
    reinstate: (vendorId) => api.post(`/api/admin/vendor-performance/${vendorId}/reinstate`),
    override: (vendorId, body) => api.post(`/api/admin/vendor-performance/${vendorId}/override`, body),
    recompute: (vendorId) =>
        api.post(`/api/admin/vendor-performance/recompute${vendorId ? `?vendor_id=${vendorId}` : ''}`),
    getConfig: () => api.get('/api/admin/vendor-performance/config'),
    putConfig: (body) => api.put('/api/admin/vendor-performance/config', body),
    breaches: (status = 'open') => api.get(`/api/admin/dispatch-breaches?status=${status}`),
    resolveBreach: (id, body) => api.post(`/api/admin/dispatch-breaches/${id}/resolve`, body),
};
